// extracted by mini-css-extract-plugin
module.exports = {"GetInTouch":"GetInTouch_GetInTouch__1U9Tb","whatNext":"GetInTouch_whatNext__3lQED","aboutWhatNext":"GetInTouch_aboutWhatNext__1pT6C"};